import localDB from "./localDB";

let GLOBAL = require('./globals');

const StoreProfileData = {
    async getSocialNetworks() {
        const response = await fetch(`${GLOBAL.BASE_URL}store/social`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    updateSocialNetworks(data, res) {
        fetch(`${GLOBAL.BASE_URL}store/social`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => {
            res(responseData);
        }).catch((err) => {
            res({update: false})
        });
    },
    async ticketService(data, res) {
        await fetch(`${GLOBAL.BASE_URL}store/services/ticket`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async getLogo() {
        const response = await fetch(`${GLOBAL.BASE_URL}store/logo`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async changeLogo(file, res) {
        let data = new FormData();
        data.append("file", file);
        await fetch(`${GLOBAL.BASE_URL}store/logo`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            'dataType': 'json',
            body: JSON.stringify(file)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
};

export default StoreProfileData;



// WEBPACK FOOTER //
// ./src/data/StoreProfileData.js